import {Brand} from '../Brand';
import {bgmiBase} from './bgmiBase';
import {BgmiLogo} from './BgmiLogo';

export const bgmi: Brand = {
  ...bgmiBase,
  assets: {
    logo: BgmiLogo,
  },
};
